import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Amplify } from 'aws-amplify';
import config from './aws-exports';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import Welcome from "./routes/welcome";
import ErrorPage from "./routes/error";
import EventMenu from './routes/eventMenu';
import EventNew from './routes/eventNew';
import EventBasketCalories from './routes/eventBasketCalories';
import EventBasketCheckout from './routes/eventBasketCheckout';
import UserData from './routes/userData';
import UserDataInitial from './routes/userDataInitial';
import EventBasketSalt from './routes/eventBasketSalt';
import CheckoutComplete from './routes/checkoutComplete';
import EventBasketWater from './routes/eventBasketWater';


const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/",
        element: <EventMenu />,
      },
      {
        path: "event/menu",
        element: <EventMenu />
      },
      {
        path: "event/new",
        element: <EventNew />
        
      },
      {
        path: "event/new/:id/basket/calories",
        element: <EventBasketCalories />
      },
      {
        path: "event/new/:id/basket/salt",
        element: <EventBasketSalt />
      },
      {
        path: "event/new/:id/basket/water",
        element: <EventBasketWater />
      },
      {
        path: "event/new/:id/basket/checkout",
        element: <EventBasketCheckout />
      },
      {
        path: "event/complete",
        element: <CheckoutComplete />
      },
      {
        path: "/user",
        element: <UserData />
      },
      {
        path: "/user-initial",
        element: <UserDataInitial />
      }
    ],
  },
]);

Amplify.configure(config);


ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
